const filterButtons = document.querySelectorAll(".filter-button");
const projectCards = document.querySelectorAll(".project-card");
const loadMoreButton = document.querySelector("#loadMoreProjects");
const projectCountStatus = document.querySelector("#projectCountStatus");
const pageSize = 24;
let activeFilter = "all";
let visibleProjects = pageSize;

function updateProjects() {
  const matchingCards = [...projectCards].filter(
    (card) => activeFilter === "all" || card.dataset.category === activeFilter,
  );

  projectCards.forEach((card) => {
    const matches = activeFilter === "all" || card.dataset.category === activeFilter;
    const matchIndex = matchingCards.indexOf(card);
    card.classList.toggle("is-hidden", !matches);
    card.classList.toggle("is-page-hidden", matches && matchIndex >= visibleProjects);
  });

  const shown = Math.min(visibleProjects, matchingCards.length);
  const remaining = Math.max(0, matchingCards.length - shown);

  if (loadMoreButton) {
    loadMoreButton.hidden = remaining === 0;
    loadMoreButton.textContent = remaining > 0
      ? `Show more projects (${remaining})`
      : "All projects shown";
  }

  if (projectCountStatus) {
    projectCountStatus.textContent = `Showing ${shown} of ${matchingCards.length} projects`;
  }
}

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    activeFilter = button.dataset.filter;
    visibleProjects = pageSize;

    filterButtons.forEach((item) => {
      item.classList.remove("is-active");
      item.setAttribute("aria-pressed", "false");
    });
    button.classList.add("is-active");
    button.setAttribute("aria-pressed", "true");

    updateProjects();
  });
});

loadMoreButton?.addEventListener("click", () => {
  visibleProjects += pageSize;
  updateProjects();
});

updateProjects();

const featuredCarousel = document.querySelector("[data-featured-carousel]");
const featuredSlides = [...document.querySelectorAll("[data-featured-slide]")];
const featuredDots = [...document.querySelectorAll("[data-featured-dot]")];
const featuredPrev = document.querySelector("[data-featured-prev]");
const featuredNext = document.querySelector("[data-featured-next]");

if (featuredCarousel && featuredSlides.length && featuredDots.length && featuredPrev && featuredNext) {
  let featuredIndex = 0;
  let featuredTimer;
  let featuredPauseTimer;
  const featuredInterval = 6500;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const showFeaturedSlide = (targetIndex) => {
    featuredIndex = (targetIndex + featuredSlides.length) % featuredSlides.length;

    featuredSlides.forEach((slide, index) => {
      const active = index === featuredIndex;
      slide.hidden = !active;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));
    });

    featuredDots.forEach((dot, index) => {
      const active = index === featuredIndex;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-selected", String(active));
    });
  };

  const startFeaturedCarousel = () => {
    window.clearInterval(featuredTimer);
    if (reduceMotion.matches || document.hidden) return;
    featuredTimer = window.setInterval(() => {
      showFeaturedSlide(featuredIndex + 1);
    }, featuredInterval);
  };

  const pauseFeaturedCarousel = () => {
    window.clearInterval(featuredTimer);
    window.clearTimeout(featuredPauseTimer);
    featuredPauseTimer = window.setTimeout(startFeaturedCarousel, featuredInterval * 2);
  };

  const moveFeaturedCarousel = (direction) => {
    showFeaturedSlide(featuredIndex + direction);
    pauseFeaturedCarousel();
  };

  featuredPrev.addEventListener("click", () => moveFeaturedCarousel(-1));
  featuredNext.addEventListener("click", () => moveFeaturedCarousel(1));
  featuredDots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      showFeaturedSlide(index);
      pauseFeaturedCarousel();
    });
  });

  featuredCarousel.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      moveFeaturedCarousel(event.key === "ArrowLeft" ? -1 : 1);
    }
  });
  featuredCarousel.addEventListener("mouseenter", () => window.clearInterval(featuredTimer));
  featuredCarousel.addEventListener("mouseleave", startFeaturedCarousel);
  featuredCarousel.addEventListener("focusin", () => window.clearInterval(featuredTimer));
  featuredCarousel.addEventListener("focusout", startFeaturedCarousel);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) window.clearInterval(featuredTimer);
    else startFeaturedCarousel();
  });
  reduceMotion.addEventListener?.("change", startFeaturedCarousel);

  showFeaturedSlide(0);
  startFeaturedCarousel();
}

const caseSlider = document.querySelector("#caseSlider");
const caseSliderCards = [...document.querySelectorAll("#caseSlider .case-card")];
const caseSliderPrev = document.querySelector("[data-case-prev]");
const caseSliderNext = document.querySelector("[data-case-next]");
const caseSliderStatus = document.querySelector("#caseSliderStatus");

if (caseSlider && caseSliderCards.length && caseSliderPrev && caseSliderNext && caseSliderStatus) {
  let caseSliderFrame;

  const cardsPerView = () => (window.matchMedia("(max-width: 750px)").matches ? 1 : 2);
  const closestCardIndex = () => {
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    caseSliderCards.forEach((card, index) => {
      const distance = Math.abs(card.offsetLeft - caseSlider.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const updateCaseSlider = () => {
    const perView = cardsPerView();
    const currentIndex = closestCardIndex();
    const totalPages = Math.ceil(caseSliderCards.length / perView);
    const currentPage = Math.min(totalPages, Math.floor(currentIndex / perView) + 1);

    caseSliderStatus.textContent = `${currentPage} / ${totalPages}`;
    caseSliderPrev.disabled = currentIndex <= 0;
    caseSliderNext.disabled = currentIndex >= caseSliderCards.length - perView;
  };

  const moveCaseSlider = (direction) => {
    const perView = cardsPerView();
    const currentIndex = closestCardIndex();
    const targetIndex = Math.max(
      0,
      Math.min(caseSliderCards.length - perView, currentIndex + direction * perView),
    );

    caseSlider.scrollTo({
      left: caseSliderCards[targetIndex].offsetLeft,
      behavior: "smooth",
    });
  };

  caseSliderPrev.addEventListener("click", () => moveCaseSlider(-1));
  caseSliderNext.addEventListener("click", () => moveCaseSlider(1));
  caseSlider.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      moveCaseSlider(event.key === "ArrowLeft" ? -1 : 1);
    }
  });
  caseSlider.addEventListener("scroll", () => {
    cancelAnimationFrame(caseSliderFrame);
    caseSliderFrame = requestAnimationFrame(updateCaseSlider);
  }, { passive: true });
  window.addEventListener("resize", updateCaseSlider);

  updateCaseSlider();
}
